<template>
  <div id="pageExtendingRequest" class="container mx-auto">
    <v-container fluid grid-list-xl>
      <div id="sent" v-if="this.sent">
        <h1>Agora é só aguardar ...</h1>
        <p>
          O estagiário já recebeu a tua solicitação e vai analisar. Vamos te
          responder em até 48 horas, ok?
        </p>
        <p>Abraço do Estagiário,😉</p>
      </div>
      <v-card
        v-else
        :loading="this.loading"
        class="mx-auto my-12"
        max-width="800"
      >
        <div class="video-wrapper">
          <iframe
            src="https://player-vz-6b763bac-40b.tv.pandavideo.com.br/embed/?v=2f81f31c-31ec-4666-a8a0-b4a9c692aff1"
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture"
            allowfullscreen
            fetchpriority="high"
          ></iframe>
        </div>
        <v-card-title class="headline" primary-title>
          Solicitação de Prorrogação
        </v-card-title>
        <v-card-text>
          Escolha o curso que deseja prorrogar e conte-nos o motivo
          <div class="mt-1">
            <v-form ref="form">
              <v-autocomplete
                v-if="this.enrollments"
                v-model="model.enrollmentId"
                v-validate="'required'"
                :disabled="loading"
                :error-messages="errors.collect('curso')"
                :items="uniqueCourses"
                :v-errors="errors"
                chips
                clearable
                data-vv-name="curso"
                item-text="course.course"
                item-value="id"
                label="Curso"
                outlined
                required
                @change="onCourseChanged"
              >
                <template v-slot:selection="data">
                  <v-chip>
                    {{
                      data.item.course.course +
                      " (término " +
                      data.item.days_to_go +
                      ")"
                    }}
                  </v-chip>
                </template>
              </v-autocomplete>
              <v-alert
                :value="!this.enrollmentEligible"
                type="warning"
                icon="warning"
              >
                {{ this.alertMessage }}
              </v-alert>
              <v-textarea
                v-model="model.comments"
                v-validate="'required'"
                :error-messages="errors.collect('comentário')"
                :v-errors="errors"
                auto-grow
                color="deep-purple"
                counter="300"
                data-vv-name="comentário"
                filled
                placeholder="Conte-nos por que você precisa de mais prazo"
                rows="1"
                @keyup="validateExtending()"
                maxlength="300"
              ></v-textarea>
            </v-form>
          </div>
        </v-card-text>
        <v-divider class="mx-4"></v-divider>
        <v-card-actions class="v-card--flat">
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!this.validRequest"
            color="primary"
            min-width="120"
            @click="submit()"
            :loading="loading"
          >
            Enviar Solicitação
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import EnrollmentService from "../../services/enrollments.service";
import RequestService from "../../services/requests.service";
import Util from "@/util/index.js";

export default {
  $_veeValidate: {
    validator: "new",
  },
  data() {
    return {
      model: {
        enrollmentId: this.$route.params.enrollmentId
          ? parseInt(this.$route.params.enrollmentId)
          : null,
        comments: null,
      },
      alertMessage: null,
      loading: false,
      enrollments: null,
      enrollmentEligible: true,
      validRequest: false,
      sent: false,
    };
  },
  async mounted() {
    await this.loadEnrollments();
    if (
      this.$route.params.enrollmentId &&
      this.enrollments &&
      this.enrollments.length > 0
    ) {
      const enrollmentId = parseInt(this.$route.params.enrollmentId);
      const enrollmentExists = this.enrollments.some(
        (e) => e.id === enrollmentId,
      );
      if (enrollmentExists) {
        this.model.enrollmentId = enrollmentId;
        this.validateExtending();
      } else {
        const courseId = this.$route.params.courseId;
        if (courseId) {
          const sameCourseMaybe = this.enrollments.find(
            (e) => e.course.id === parseInt(courseId),
          );
          if (sameCourseMaybe) {
            this.model.enrollmentId = sameCourseMaybe.id;
            this.validateExtending();
          }
        }
      }
    }
  },
  computed: {
    uniqueCourses() {
      if (!Array.isArray(this.enrollments)) return [];
      const courseMap = new Map();
      this.enrollments.forEach((item) => {
        if (!item.course || !item.course.id) return;
        const courseId = item.course.id;
        if (
          !courseMap.has(courseId) ||
          new Date(item.expiration_date) >
            new Date(courseMap.get(courseId).expiration_date)
        ) {
          courseMap.set(courseId, item);
        }
      });
      const routeEnrollmentId = this.$route.params.enrollmentId
        ? parseInt(this.$route.params.enrollmentId)
        : null;
      if (routeEnrollmentId) {
        const enrollmentFromRoute = this.enrollments.find(
          (e) => e.id === routeEnrollmentId,
        );
        if (enrollmentFromRoute && enrollmentFromRoute.course) {
          courseMap.set(enrollmentFromRoute.course.id, enrollmentFromRoute);
        }
      }

      return Array.from(courseMap.values());
    },
  },
  methods: {
    submit() {
      this.formHasErrors().then((hasError) => {
        console.log(hasError);
        if (!hasError) {
          this.loading = true;
          RequestService.submitExtendingRequest(this.model)
            .then((res) => {
              this.sent = true;
              this.loading = false;
            })
            .catch((e) => {
              this.loading = false;
              console.log(e.message);
            });
        } else {
          console.log(hasError);
        }
      });
    },
    async loadEnrollments() {
      try {
        const routeEnrollmentId = this.$route.params.enrollmentId
          ? parseInt(this.$route.params.enrollmentId)
          : null;

        const routeCourseId = this.$route.params.courseId
          ? parseInt(this.$route.params.courseId)
          : null;

        const response = await EnrollmentService.getMyExtendableEnrollments();
        this.enrollments = response.data;

        if (routeEnrollmentId) {
          const enrollmentExists = this.enrollments.some(
            (e) => e.id === routeEnrollmentId,
          );

          if (enrollmentExists) {
            this.model.enrollmentId = routeEnrollmentId;
          } else if (routeCourseId) {
            const sameCourseEnrollment = this.enrollments.find(
              (e) => e.course && e.course.id === routeCourseId,
            );

            if (sameCourseEnrollment) {
              this.model.enrollmentId = sameCourseEnrollment.id;
            } else if (routeEnrollmentId) {
              try {
                const specificEnrollment =
                  await EnrollmentService.getEnrollment(routeEnrollmentId);
                if (specificEnrollment && specificEnrollment.data) {
                  this.enrollments.push(specificEnrollment.data);
                  this.model.enrollmentId = routeEnrollmentId;
                }
              } catch (error) {
                console.log("Erro ao buscar matrícula específica:", error);
              }
            }
          }
          this.validateExtending();
        }

        this.loading = false;
      } catch (error) {
        console.log("error", error);
        this.loading = false;
      }
    },

    async mounted() {
      await this.loadEnrollments();
    },
    onCourseChanged() {
      this.validateExtending();
    },
    validateExtending() {
      if (!this.model.enrollmentId || !this.enrollments) return;

      let e = this.enrollments
        .filter((obj) => {
          return obj.id === this.model.enrollmentId;
        })
        .shift();

      if (!e) return;

      console.log(Util);
      const expirationDate = Util.toDate(e.expiration_date);
      const days = Util.dateDiffInDays(new Date(), expirationDate);
      this.enrollmentEligible = days < 31;
      if (!this.enrollmentEligible)
        this.alertMessage = `Restam mais de 30 dias para expiração deste curso`;
      this.validRequest =
        this.enrollmentEligible && this.model.comments !== null;
    },
  },
};
</script>
<style>
.video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
  height: 0;
}

.video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}
</style>
